/* eslint-disable no-console */
import {dataAPI} from './api';
import {setFilters} from '../Actions/filters';
import {setLaborProcessFilters} from '../Actions/laborProcessFilters';
import {setErrorState} from '../Actions/errorHandler';
import {setAuthorizedState} from '../Actions/loginHandler';
//import {download} from '../Libs/downloadLogic';
import {saveAs} from "file-saver";
import Alert from 'react-s-alert';
import { toast } from 'react-toastify';
import {setPartsFilters} from "../Actions/partsFilters";
import {setIsFileDownloaded} from "../Actions/download";


export function loadDataFromAPI (filterSettings = {}, accessToken, username) {
    const queryString = Object.keys(filterSettings).map( filterKey =>
        filterSettings[filterKey] === '' ? '' : filterKey + '=' + filterSettings[filterKey] + '&'
    ).join('').slice(0,-1);
    const url = `materialTriggerEmail?${queryString}&emailAddress=${username}`;
    return dispatch => {
        dataAPI ({
            method  : 'get',
            url     : url,
            headers : {
                Authorization : 'Bearer ' + accessToken
            }
        }).then(
            () => {
                toast.success("Your Material/Supplied Material/Material Color search result will be emailed in few minutes");
                //download(dataSuccess.data, filterSettings.beginDate, filterSettings.endDate, filterSettings.version);
                dispatch(setAuthorizedState(true));
                dispatch(setFilters(filterSettings));
            }
        ).catch((error) => {
            dispatch(setAuthorizedState(true));
            switch(error.response.status) {
                case 404:
                    Alert.error('Material API endpoint not found.', {
                        offset : 80
                    });
                    break;
                case 400:
                    Alert.error('Bad request', {
                        offset : 80
                    });
                    break;
                case 401:
                    dispatch(setErrorState({code : error.response.status, message : 'You are not authorized to use this application.', type : 'material'}));
                    break;
                case 502:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please Try Refreshing the Page', type : 'material'}));
                    break;
                case 500:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please Try Refreshing the Page', type : 'material'}));
                    break;
                default:
                    break;
            }
        });
    };
}


export function partsTriggerEmailAPI (filterSettings = {}, accessToken, username) {
    const queryString = Object.keys(filterSettings).map( filterKey =>
        filterSettings[filterKey] === '' ? '' : filterKey + '=' + filterSettings[filterKey] + '&'
    ).join('').slice(0,-1);
    const url = `partsTriggerEmail?${queryString}&emailAddress=${username}`;
    return dispatch => {
        dataAPI ({
            method  : 'get',
            url     : url,
            headers : {
                Authorization : 'Bearer ' + accessToken
            }
        }).then(
            () => {
                toast.success("Your Parts search result will be emailed in few minutes");
                //download(dataSuccess.data, filterSettings.beginDate, filterSettings.endDate, filterSettings.version);
                dispatch(setAuthorizedState(true));
                dispatch(setPartsFilters(filterSettings));
            }
        ).catch((error) => {
            dispatch(setAuthorizedState(true));
            switch(error.response.status) {
                case 404:
                    Alert.error('Parts API endpoint not found.', {
                        offset : 80
                    });
                    break;
                case 401:
                    dispatch(setErrorState({code : error.response.status, message : 'You are not authorized to use Parts Filter.', type : 'parts'}));
                    break;
                case 502:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please retry', type : 'parts'}));
                    break;
                case 500:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please retry', type : 'parts'}));
                    break;
                default:
                    break;
            }
        });
    };
}

export function laborProcessTriggerEmailAPI (filterSettings = {}, accessToken, username) {
    const queryString = Object.keys(filterSettings).map( filterKey =>
        filterSettings[filterKey] === '' ? '' : filterKey + '=' + filterSettings[filterKey] + '&'
    ).join('').slice(0,-1);
    const url = `laborProcessTriggerEmail?${queryString}&emailAddress=${username}`;
    return dispatch => {
        dataAPI ({
            method  : 'get',
            url     : url,
            headers : {
                Authorization : 'Bearer ' + accessToken
            }
        }).then(
            () => {
                toast.success("Your Labor Process search result will be emailed in few minutes");
                //download(dataSuccess.data, filterSettings.beginDate, filterSettings.endDate, filterSettings.version);
                dispatch(setAuthorizedState(true));
                dispatch(setLaborProcessFilters(filterSettings));
            }
        ).catch((error) => {
            dispatch(setAuthorizedState(true));
            switch(error.response.status) {
                case 404:
                    Alert.error('Labor Process API endpoint not found.', {
                        offset : 80
                    });
                    break;
                case 401:
                    dispatch(setErrorState({code : error.response.status, message : 'You are not authorized to use Labor Process Filter.', type : 'Labor Process'}));
                    break;
                case 502:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please retry', type : 'Labor Process'}));
                    break;
                case 500:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Please retry', type : 'Labor Process'}));
                    break;
                default:
                    break;
            }
        });
    };
}

export function downloadJSON (accessToken,filename,reportType) {
    //let filename = localStorage.getItem ('filename');
    const url = `downloadJSON?fileName=${filename}&reportType=${reportType}`;
    let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?fileName=${filename}&reportType=${reportType}`;
    window.history.pushState ({path : newurl}, '', newurl);
    return dispatch => {
        dataAPI ({
            method       : 'get',
            url          : url,
            responseType : 'blob',
            headers      : {
                Authorization : 'Bearer ' + accessToken
            }
        }).then(dataSuccess => {
            dispatch(setAuthorizedState(true));
            dispatch(setIsFileDownloaded(true));
            saveAs(dataSuccess.data,filename);
        }
        ).catch((error) => {
            dispatch(setAuthorizedState(true));
            switch(error.response.status) {
                case 401:
                    dispatch(setErrorState({code : error.response.status, message : 'You are not authorized to download'}));
                    break;
                case 502:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable -  Bad gateway'}));
                    break;
                case 500:
                    dispatch(setErrorState({code : error.response.status, message : 'Server Unavailable'}));
                    break;
                default:
                    break;
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/APIs/dataHelper.js